// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b1feb8d7","82":"3e26583a","690":"7f8541a8","787":"917857b7","793":"ecd46c65","842":"32d27c6d","964":"232e0002","978":"defd285f"}[chunkId] + ".chunk.js";
};